import PropTypes from "prop-types";
import React, {Component} from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Neodinamika — Онлайн игры от создателей Космических рейнджеров, King's Bounty и Вангеров!"/>
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
                </Helmet>
            </React.Fragment>
        )
    }
}

PageHelmet.propTypes = {
    title: PropTypes.string
};
export default PageHelmet;
